





























































import { computed, defineComponent, PropType } from '@nuxtjs/composition-api';
import dayjs from 'dayjs';
import AppAvatar from '~/components/partials/App/AppAvatar.vue';
import AppContentCardThumbnail from '~/components/partials/App/AppContentCardThumbnail.vue';
import AppContentFavoriteIconButton from '~/components/partials/App/AppContentFavoriteIconButton.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import { useListFavorite } from '~/composables/contents/useListFavorite';
import { THUMBNAIL_300, THUMBNAIL_250 } from '~/constants/profilesForImage';
import { url } from '~/utils';
import { sendGaEvent as sendEvent, GaTopPartsType } from '~/utils/ga';
import { ArticleCard, ArticleCategory, EditorProfile } from '~/types/modules/contents';
import { FavoriteTypes } from '~/enums';

export default defineComponent({
  components: {
    AppLink,
    AppAvatar,
    AppContentCardThumbnail,
    AppContentFavoriteIconButton,
  },
  props: {
    item: {
      type: Object as PropType<ArticleCard>,
      required: true,
    },
    authors: {
      type: Array as PropType<EditorProfile[]>,
      default: () => [],
    },
    categories: {
      type: Array as PropType<ArticleCategory[]>,
      default: () => [],
    },
    gaPartsType: {
      type: String as PropType<GaTopPartsType>,
      default: null,
    },
    isRelatedContents: {
      type: Boolean,
      default: false,
    },
    isFavButtonHidden: {
      type: Boolean,
      default: false,
    },
    // トップページ用にデザインを調整
    isTopContents: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { checkIsFavorite } = useListFavorite();

    const detailUrl = computed(() => url('ARTICLE_DETAIL', { permalink: props.item.permalink }));
    const author = computed(() => props.authors.find(({ id }) => id === props.item.authorId));
    const authorUrl = computed(() => author.value && url('ARTICLE_LIST_AUTHOR', { permalink: author.value.permalink }));
    const category = computed(() => props.categories.find(({ id }) => id === Number(props.item.categoryId)));
    const categoryUrl = computed(
      () => category.value && url('ARTICLE_LIST_CATEGORY', { permalink: category.value.permalink })
    );
    const publishedAt = computed(() => dayjs(props.item.publishedAt).tz('Asia/Tokyo').format('YYYY.M.D'));
    const articleId = computed(() => props.item.id.replace('article_', ''));
    const isFavorite = computed(() => checkIsFavorite(articleId.value, FavoriteTypes.ARTICLE));
    const thumbnailImageSp = computed(() =>
      props.item.thumbnailImageSp ? props.item.thumbnailImageSp + THUMBNAIL_250 : undefined
    );
    const thumbnailImagePc = computed(() =>
      props.item.thumbnailImagePc ? props.item.thumbnailImagePc + THUMBNAIL_300 : undefined
    );
    const mainImageSp = computed(() => (props.item.mainImageSp ? props.item.mainImageSp + THUMBNAIL_250 : undefined));
    const mainImagePc = computed(() => (props.item.mainImagePc ? props.item.mainImagePc + THUMBNAIL_300 : undefined));

    const sendGaEvent = () => {
      if (!props.gaPartsType) {
        return;
      }
      sendEvent(props.gaPartsType, detailUrl.value, props.item.title);
    };

    return {
      thumbnailImageSp,
      thumbnailImagePc,
      mainImageSp,
      mainImagePc,
      detailUrl,
      author,
      authorUrl,
      category,
      categoryUrl,
      publishedAt,
      sendGaEvent,
      isFavorite,
      articleId,
    };
  },
});
